import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <div>

      {/* Banner Section */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="contact-banner-image" />
        <div className="banner-caption">
          <h1>Privacy Policy</h1>
          <ul className="breadcumb">
            <li><a href="#">Home</a> - </li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </div>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At Anjali Enterprises, we value your privacy and are dedicated to protecting your personal information. This Privacy Policy outlines the data we collect, how we use it, and how we safeguard it.
              </p>

              <div className="section">
                <p className="highlight darkcolor">Information We Collect:</p>
                <p className="highlight darkcolor">1. Personal Information:</p>
                <p>
                  We collect personal information such as your name, phone number, email, and other details necessary to provide our services.
                </p>

                <p className="highlight darkcolor">2. Usage Data:</p>
                <p>
                  We collect browsing information such as IP address, device information, and browsing patterns to enhance the user experience on our website.
                </p>

                <p className="highlight darkcolor">3. Location Data:</p>
                <p>
                  With your consent, we may collect location data to assist with services like site visits or installations.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>
                <p className="highlight darkcolor">1. Service Delivery:</p>
                <p>
                  We use your details to confirm service bookings, deliver our products, and process payments.
                </p>

                <p className="highlight darkcolor">2. Service Improvement:</p>
                <p>
                  The data collected helps us enhance our offerings, address issues, and introduce better features.
                </p>

                <p className="highlight darkcolor">3. Communication:</p>
                <p>
                  We send service confirmations, updates, and notifications via SMS and email.
                </p>

                <p className="highlight darkcolor">4. Marketing & Promotions:</p>
                <p>
                  With your consent, we may send you promotional offers, service updates, and special deals.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>
                <p className="highlight darkcolor">1. Trusted Partners:</p>
                <p>
                  We may share relevant information with trusted partners for payment processing and customer service purposes.
                </p>

                <p className="highlight darkcolor">2. Legal Compliance:</p>
                <p>
                  We may disclose information when required by law or to protect our rights and safety.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We take reasonable security measures to protect your personal information, although no method of online transmission is 100% secure.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You have the right to request access to, corrections to, or deletion of your personal data. You can also opt out of marketing communications.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  We may update this Privacy Policy periodically, and we encourage you to review it regularly for changes.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any concerns or questions regarding our privacy practices, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918793220265">+91 8793220265</a></li>
              <li><b>Email:</b> <a href="mailto:info@anjalienterprisesindia.com">info@anjalienterprisesindia.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
